import type { LinkFilterViewModel } from 'autogen/swagger/all';
import ButtonWithActiveState from 'components/Button/ButtonWithActiveState';
import useFilterMenu from '../../FilterMenu/shared/hooks/useFilterMenu';

export default function LinkFilterMenuOpener({
    model: {
        displayName,
        isActive,
        attribute,
        attribute: { id }
    },
    ...restProps
}: {
    model: LinkFilterViewModel;
}) {
    const filterMenuId = id.toString();
    const { openFilterMenu } = useFilterMenu(filterMenuId);
    const shouldDisplayFilterButton = attribute.location === 'Above';

    return (
        <>
            {shouldDisplayFilterButton && (
                <ButtonWithActiveState size="lg" isActive={isActive} onClick={openFilterMenu} {...restProps}>
                    {displayName}
                </ButtonWithActiveState>
            )}
        </>
    );
}
